<template>
  <div v-loading="loading">
    <table class="tbl">
      <thead>
        <tr>
          <th style="width: 190px">操作日期</th>
          <th style="width: 210px">操作人员</th>
          <th>操作记录</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, idx) in logList" :key="idx">
          <td>{{ row.time || "--" }}</td>
          <td>{{ row.operator || "--" }}</td>
          <td>{{ row.record || "--" }}</td>
        </tr>
        <tr v-if="!logList.length">
          <td colspan="3" class="cell-empty">暂无操作记录</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { getVehicleArchiveDetail } from "@/api/vehicleArchive";

export default {
  name: "VehicleOperLog",
  props: {
    code: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      detail: null
    };
  },
  computed: {
    // 与详情页「动态日志」Tab 一致：变更日志 + 操作日志合并、时间倒序
    logList() {
      const rows = [];
      const d = this.detail;
      if (d) {
        const changeList = Array.isArray(d.changeLogList)
          ? d.changeLogList
          : [];
        const operList = Array.isArray(d.operLogList) ? d.operLogList : [];
        changeList.forEach(item => {
          rows.push({
            time: this.fmtDT(item.operateTime),
            operator: this.operatorText(item.operator, item.sourceText),
            record: item.record || ""
          });
        });
        operList.forEach(item => {
          rows.push({
            time: this.fmtDT(item.operateTime),
            operator: (item.operator ? item.operator : "系统") + "（运营后台）",
            record: item.record || ""
          });
        });
      }
      rows.sort((a, b) => {
        const ta = a.time || "";
        const tb = b.time || "";
        return ta < tb ? 1 : ta > tb ? -1 : 0;
      });
      return rows;
    }
  },
  created() {
    if (this.code) {
      this.load();
    }
  },
  methods: {
    load() {
      this.loading = true;
      getVehicleArchiveDetail(this.code)
        .then(response => {
          this.detail = response.data || null;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    operatorText(operator, sourceText) {
      const name = operator || "";
      const map = {
        实际承运人自助: "本人",
        客服确认: "客服",
        运营后台: "运营"
      };
      const suffix = map[sourceText] || sourceText || "";
      return name + (suffix ? "（" + suffix + "）" : "");
    },
    fmtDT(v) {
      if (!v) return "";
      const s = String(v)
        .replace("T", " ")
        .trim();
      return s.slice(0, 19);
    }
  }
};
</script>

<style lang="scss" scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
  border-top: 1px solid #e8ecf3;
  border-left: 1px solid #e8ecf3;

  th {
    background: #f7f9fc;
    color: #8a93a6;
    font-weight: 500;
    font-size: 12.5px;
    text-align: left;
    padding: 11px 16px;
    border-right: 1px solid #e8ecf3;
    border-bottom: 1px solid #e8ecf3;
    white-space: nowrap;
  }

  td {
    padding: 12px 16px;
    border-right: 1px solid #e8ecf3;
    border-bottom: 1px solid #e8ecf3;
    color: #4b5568;
    vertical-align: middle;
    line-height: 1.6;
    word-break: break-all;

    &.cell-empty {
      text-align: center;
      color: #8a93a6;
      font-weight: 400;
      padding: 28px 16px;
    }
  }

  tr:last-child td {
    border-bottom: none;
  }
}
</style>
